import React, { Component } from 'react';
import * as api from '../../api';
import 'semantic-ui-css/semantic.min.css';
import WithoutPagingDatatable from "../../components/table/data-table-without-pageing";
import ProductionParametersTableHeader from "./site-table-production-parameters-header";
import SiteTableProductionparametersRow from "./productionparameters-table-row";
import ApiDataProvider_withpage from "../../components/table/data-providers/api-data-provider_withpage"

export default class SiteTableProductionParaHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {

            dataProvider: new ApiDataProvider_withpage(api.getProductionParameterDetail, [this.props.siteKey])

        };
    }
     render() {
        return (
            <WithoutPagingDatatable dataProvider={this.state.dataProvider}
                contextData={{ siteKey: this.props.siteKey }}
                defaultSort={"id"} headerComponent={ProductionParametersTableHeader}
                rowComponent={SiteTableProductionparametersRow} />
        );
    }
}